function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.51 13.543c0-1.139.139-2.046.415-2.722.277-.675.782-1.338 1.514-1.99.74-.659 1.233-1.192 1.477-1.599.244-.415.366-.85.366-1.306 0-1.375-.635-2.063-1.904-2.063-.602 0-1.087.187-1.453.562-.358.366-.545.875-.561 1.526H.824C.84 4.396 1.34 3.18 2.325 2.3 3.318 1.42 4.67.982 6.378.982c1.725 0 3.064.42 4.016 1.258.952.83 1.428 2.006 1.428 3.528 0 .691-.154 1.346-.464 1.965-.309.61-.85 1.29-1.623 2.038l-.989.94c-.618.595-.972 1.29-1.062 2.088l-.049.745H4.51zm-.354 3.748c0-.545.183-.993.55-1.343.374-.358.85-.537 1.428-.537s1.05.18 1.416.537c.374.35.561.798.561 1.343 0 .537-.183.98-.549 1.33-.358.35-.834.526-1.428.526s-1.074-.175-1.44-.525c-.359-.35-.538-.794-.538-1.331z",
  fill: "#fff"
});

function SvgQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    fill: "none"
  }, props), _ref);
}

export default SvgQuestionMark;